export default __webpack_public_path__ + "static/media/OG-BNB.10565989.svg";